import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home/index' // news
import vpn from '@/components/vpn/index'
import box from '@/components/box/index'
import agent from '@/components/agent/index'
import buy from '@/components/buy/index'
import news from '@/components/news/index'
import corporate from '@/components/corporate/index'
import contact from '@/components/contact/index'
import yinsi from '@/components/yinsi/index'
import statute from '@/components/statute/index'
import agentLogin from '@/components/agentLogin/index'
import agentBuy from '@/components/agentBuy/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },

    {
      path: '/vpn',
      name: 'vpn',
      component: vpn
    },
    {
      path: '/box',
      name: 'box',
      component: box
    },
    {
      path: '/agent',
      name: 'agent',
      component: agent
    },
    {
      path: '/buy',
      name: 'buy',
      component: buy
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/corporate',
      name: 'corporate',
      component: corporate
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/yinsi',
      name: 'yinsi',
      component: yinsi
    },
    {
      path: '/statute',
      name: 'statute',
      component: statute
    },
    {
      path: '/agentLogin',
      name: 'agentLogin',
      component: agentLogin,
      meta: {
        noTop: true, // 不需要头部和底部
      }
    },
    {
      path: '/agentBuy',
      name: 'agentBuy',
      component: agentBuy,
      meta: {
        noTop: true, // 不需要头部和底部
        requireAuth: true,
        agentTop: true
      }
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js